import { Component, Inject, OnInit } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { DOCUMENT, Location } from '@angular/common';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { isAlphabeticalRoute } from '@app/constants/viewTypes.constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public labels = {
    goBack: marker('common.goBack')
  };
  private actualUrl: string;
  private scrollPositions: { [url: string]: number } = {};
  private restorePosition = false;

  constructor(private router: Router, private location: Location, @Inject(DOCUMENT) private document: Document) {}

  ngOnInit(): void {
    // Escucha los eventos de navegación
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart || event instanceof NavigationEnd))
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          const scrollPosition =
            document.getElementById('mainContent')?.getElementsByClassName('mat-drawer-content')[0].scrollTop || 0;
          const path = this.actualUrl ? this.actualUrl : this.location.path();
          this.scrollPositions[path] = scrollPosition;
          this.goToTop();
          // console.log(this.scrollPositions);
        } else if (event instanceof NavigationEnd) {
          this.actualUrl = this.location.path();
          if (this.restorePosition) {
            this.restoreScrollPosition();
            this.restorePosition = false;
          }
        }
      });
  }

  public showBackBtn(): boolean {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const state = this.location.getState() as any;
    return state && state.navigationId && state.navigationId > 1;
  }

  public goBackBtn(): void {
    this.location.back();
    this.restorePosition = true;
  }

  public restoreScrollPosition(): void {
    setTimeout(() => {
      const scrollPosition = this.scrollPositions[this.actualUrl];
      if (scrollPosition && document.getElementById('mainContent')?.getElementsByClassName('mat-drawer-content')[0]) {
        setTimeout(() => {
          // console.log('Setting scroll position to: ', scrollPosition);
          document.getElementById('mainContent').getElementsByClassName('mat-drawer-content')[0].scrollTop = scrollPosition;
        }, 0);
      }
    }, 400);
  }

  public goToTop(): void {
    if (document.getElementById('mainContent')?.getElementsByClassName('mat-drawer-content')) {
      document.getElementById('mainContent').getElementsByClassName('mat-drawer-content')[0].scrollTop = 0;
    }
  }

  public isAlphabeticalView(): boolean {
    return isAlphabeticalRoute(this.location.path());
  }
}
